<template>
  <div class="rabbuildr_center rabbuildrcntr">
    <div class="rabbuildrcntr_top f-column">
      <ProgressRing
        v-if="!mobile"
        :maxCircle="1"
        :max="total.score"
        :getClr="score => total.scoreGroup.clr"
      >
      </ProgressRing>
      <div class="f-center rb-finish-mesage">
        <i
          :style="`font-size: 1.5rem;color:${total.scoreGroup.clr}`"
          class="mr-2 mdi"
          :class="total.scoreGroup.icon"
        ></i>
        <div
          v-if="mobile"
          :style="`color:${total.scoreGroup.clr}`"
          class="mr-2 weight_700 text-semi-large text-nowrap uppercase"
        >
          {{ numFixed(total.score * 100) }}%
        </div>
        <div
          class="weight_700 text-semi-large text-nowrap uppercase"
          style="letter-spacing: 1px"
        >
          {{ $t(`range_builder.${total.scoreGroup.id}`) }}
        </div>
      </div>
    </div>

    <UnSwitcherNew
      v-if="showFlopContent"
      :tab="unValue"
      :options="unOptions"
      :hasText="true"
      :hasOpener="true"
      style="--gwbtn-flex: 1; --uns-opener-clr-back: rgba(255, 255, 255, 0.1)"
      @click="val => (unValue = val.payload)"
    ></UnSwitcherNew>
    <div class="rabbuildrcntr_blocks no-scroll-track mt-2 pt-2 pb-2">
      <div
        v-if="unValue === 'summary'"
        class="rabbuildrcntr_block"
      >
        <div class="rabbuildrcntr_block_items">
          <div class="rabbuildrcntr_title text_tab_small">
            {{ $t('common.total') }}
          </div>
          <div
            class="gw_box f-column"
            style="padding: 0.75rem; --clr-box-back: var(--clr-black-1-3); gap: 0.5rem"
          >
            <CompareChartBox
              v-for="(a, idx) in solution_picked.answered"
              :key="a.code"
              :isCentered="true"
              :pLeft="a.strategy"
              :pRight="solution_picked.correct[idx].total_frequency"
              :clrPrimary="a.hex"
              :clrSecondary="a.hex"
              :style="`--clr-back-winn:${a.hex};`"
              style="
                --clr-back-lose: var(--clr-back-winn);
                --clr-equal-left: var(--clr-back-winn);
                --clr-equal-right: var(--clr-back-winn);
                --grid-gap: 1px;
                --weight: 500;
                --weight-legend: 500;
              "
            >
              <template #legend_left>
                <span class="rabb_score_chart_action-value">
                  {{ numFixedUnit(a.strategy * 100, 'strategy') }}%
                </span>
              </template>
              <template #legend_center>
                <span class="rabb_score_chart_action-name">
                  {{ a.display_name || $t(`browse.${a.group_display_name}`) }}
                  <span
                    class="pl-1"
                    v-html="getBetHtml({ showBetsIn, a })"
                  ></span>
                </span>
              </template>
              <template #legend_right>
                <span class="rabb_score_chart_action-value">
                  {{
                    numFixedUnit(solution_picked.correct[idx].total_frequency * 100, 'strategy')
                  }}%
                </span>
              </template>
            </CompareChartBox>
          </div>
        </div>
      </div>
      <div class="rabbuildrcntr_block">
        <div
          v-if="unValue === 'summary'"
          class="rabbuildrcntr_block_items"
        >
          <div class="rabbuildrcntr_title text_tab_small f-center">
            {{ $t('range_builder.combos_by_score') }}
            <div
              class="csst ml-1 mr-auto"
              @mouseenter="fl_positionTooltip"
            >
              <div class="mdi mdi-help-circle-outline clr-grey"></div>
              <div
                class="csst_content clr-white"
                style="position: fixed"
              >
                <div class="capitalize text-nowrap">
                  <b> {{ $t(`range_builder.perfect`) }}</b> :
                  {{ $t(`range_builder.perfect_help`) }}
                </div>
                <div class="capitalize text-nowrap">
                  <b>{{ $t(`range_builder.good`) }}</b
                  >:
                  {{ $t(`range_builder.good_help`) }}
                </div>
                <div class="capitalize text-nowrap">
                  <b>{{ $t(`range_builder.inaccuracy`) }}</b
                  >:
                  {{ $t(`range_builder.inaccuracy_help`) }}
                </div>
                <div class="capitalize text-nowrap">
                  <b>{{ $t(`range_builder.mistake`) }}</b
                  >:
                  {{ $t(`range_builder.mistake_help`) }}
                </div>
              </div>
            </div>
          </div>
          <ExpandCard
            v-for="item in scoreGroups"
            :key="item.id"
            :opened="false"
            style="
              --radius-open: 4px;
              --min-height: 2rem;
              --content-padding: 0.25rem 0.75rem 0.75rem 0.75rem;
              --clr-back-content: var(--clr-black-2);
            "
            @mouseleave="handleScoreGroupMouseleave()"
            @mouseenter="handleScoreGroupMouseenter(item)"
            @click="handleScoreGroupClick(item)"
          >
            <template #title>
              <div class="f-center w-100 mr-2 clr-white">
                <div
                  class="mdi text-normal-large"
                  :class="item.icon"
                  :style="`color:${item.clr}`"
                ></div>
                <div class="ml-2">
                  {{ $t(`range_builder.${item.id}`) }}
                </div>
                <div class="ml-auto">
                  {{ item.totalCombos }}
                </div>
              </div>
            </template>

            <CompareChartBox
              v-for="(a, idx) in item.solution_picked.answered"
              :key="a.code"
              class="mt-2"
              :isCentered="true"
              :pLeft="a.strategy"
              :pRight="item.solution_picked.correct[idx].strategy"
              :clrPrimary="a.hex"
              :clrSecondary="a.hex"
              :style="`--clr-back-winn:${a.hex};`"
              style="
                --clr-back-lose: var(--clr-back-winn);
                --grid-gap: 1px;
                --weight: 500;
                --weight-legend: 500;
              "
            >
              <template #legend_left>
                <span class="rabb_score_chart_action-value">
                  {{ numFixedUnit(a.strategy * 100, 'strategy') }}%
                </span>
              </template>
              <template #legend_center>
                <span class="rabb_score_chart_action-name">
                  {{ a.display_name || $t(`browse.${a.group_display_name}`) }}
                  <span
                    class="pl-1"
                    v-html="getBetHtml({ showBetsIn, a })"
                  ></span>
                </span>
              </template>
              <template #legend_right>
                <span class="rabb_score_chart_action-value">
                  {{ numFixedUnit(item.solution_picked.correct[idx].strategy * 100, 'strategy') }}%
                </span>
              </template>
            </CompareChartBox>
          </ExpandCard>
        </div>
        <div
          v-for="cat in categories"
          :key="cat.id"
          class="rabbuildrcntr_block_items"
        >
          <div class="rabbuildrcntr_title text_tab_small">
            {{ cat.title }}
          </div>
          <ExpandCard
            v-for="item in cat.items"
            :key="item.id"
            :opened="false"
            style="
              --radius-open: 4px;
              --min-height: 2rem;
              --content-padding: 0.25rem 0.75rem 0.75rem 0.75rem;
              --clr-back-content: var(--clr-black-2);
            "
            @mouseleave="handleCatMouseleave()"
            @mouseenter="handleCatMouseenter(item)"
          >
            <template #title>
              <div class="f-center w-100 mr-2 clr-white">
                <div class="ml-2">
                  {{ $t(`browse.filter_rules.${item.name}`) }}
                </div>
                <div
                  class="ml-auto"
                  :style="`color:${item.total.scoreGroup.clr}`"
                >
                  {{ numFixed(item.total.score * 100, 1) }}%
                  <!-- {{ item.total.totalCombos }} -->
                </div>
              </div>
            </template>

            <CompareChartBox
              v-for="(a, idx) in item.solution_picked.answered"
              :key="a.code"
              class="mt-2"
              :isCentered="true"
              :pLeft="a.strategy"
              :pRight="item.solution_picked.correct[idx].total_frequency"
              :clrPrimary="a.hex"
              :clrSecondary="a.hex"
              :style="`--clr-back-winn:${a.hex};`"
              style="
                --clr-back-lose: var(--clr-back-winn);
                --grid-gap: 1px;
                --weight: 500;
                --weight-legend: 500;
              "
            >
              <template #legend_left>
                <span class="rabb_score_chart_action-value">
                  {{ numFixedUnit(a.strategy * 100, 'strategy') }}%
                </span>
              </template>
              <template #legend_center>
                <span class="rabb_score_chart_action-name">
                  {{ a.display_name || $t(`browse.${a.group_display_name}`) }}
                  <span
                    class="pl-1"
                    v-html="getBetHtml({ showBetsIn, a })"
                  ></span>
                </span>
              </template>
              <template #legend_right>
                <span class="rabb_score_chart_action-value">
                  {{
                    numFixedUnit(
                      item.solution_picked.correct[idx].total_frequency * 100,
                      'strategy',
                    )
                  }}%
                </span>
              </template>
            </CompareChartBox>
          </ExpandCard>
        </div>
      </div>
    </div>

    <slot name="after"></slot>
  </div>
</template>

<script>
import UnSwitcherNew from '@/components/Switchers/UnSwitcher_new'
import CompareChartBox from '@/components/Charts/CompareChartBox/CompareChartBox'
import ExpandCard from '@/components/Common/ExpandCard/ExpandCard'
import { SNK } from '@/helpers/helpers'
import { getComboMainGroup } from '@/helpers/solution'
import ProgressRing from '@/components/lib/ProgressRing'

import float_mix from '@/mixins/float_mix'
import format_mix from '@/mixins/format_mix'

export default {
  name: 'RangeBuilderCenter',
  components: {
    ProgressRing,
    UnSwitcherNew,
    CompareChartBox,
    ExpandCard,
  },
  mixins: [float_mix, format_mix],
  props: {
    namespace: { required: true },
    rab_result: { default: () => ({}) },
    showBetsIn: String,
    grouping: String,
    showFlopContent: Boolean,
    mobile: Boolean,
  },
  data() {
    return {
      unValue: 'summary',
    }
  },
  methods: {
    handleCatMouseleave() {
      this.$store.dispatch(SNK('sol_detail_highlight', this.namespace), null)
    },
    handleCatMouseenter(category) {
      this.$store.dispatch(SNK('sol_detail_highlight', this.namespace), category)
    },

    handleScoreGroupMouseleave() {
      this.handleCatMouseleave()
    },
    handleScoreGroupMouseenter(item) {
      const groups = item.combos.map(i => getComboMainGroup({ id: i.id }).group_id)

      const players = [{ groups }]
      const l_category = { hero: { groups }, opponent: { groups: [] }, players }
      this.handleCatMouseenter(l_category)
    },
    handleScoreGroupClick() {},
  },
  computed: {
    total() {
      return this.rab_result.total
    },
    solution_picked() {
      return this.rab_result.solution_picked
    },
    scoreGroups() {
      return this.rab_result.scoreGroups
    },
    categories() {
      if (!this.showFlopContent) return []
      const res = [
        {
          id: 'best',
          visible: 'summary',
          title: this.$t('range_builder.categories_best'),
          items: this.rab_result.bestCats,
        },
        {
          id: 'worst',
          visible: 'summary',
          title: this.$t('range_builder.categories_worst'),
          items: this.rab_result.worstCats,
        },
        {
          id: 'hands',
          title: this.$t('switchers.swv_hands'),
          items: this.rab_result.hands,
        },
        {
          id: 'draws',
          title: this.$t('switchers.swv_draws'),
          items: this.rab_result.draws,
        },
        {
          id: 'eqBuckets',
          title: this.$t('switchers.swv_eq_buckets_simple'),
          items: this.rab_result.eqBuckets,
        },
        {
          id: 'eqBucketsAdvanced',
          title: this.$t('switchers.swv_eq_buckets_advanced'),
          items: this.rab_result.eqBucketsAdvanced,
        },
      ].filter(i => (i.visible || i.id) === this.unValue)
      // console.log(res)
      return res
    },
    unOptions() {
      return [
        {
          text: this.$t('range_builder.summary'),
          payload: 'summary',
        },
        {
          text: this.$t('range_builder.hands'),
          payload: 'hands',
          disabled: !this.showFlopContent,
        },
        {
          text: this.$t('range_builder.draws'),
          payload: 'draws',
          disabled: !this.showFlopContent,
        },
        {
          text: this.$t('browse.filter_categories.eq_buckets'),
          payload: 'eqBuckets',
          disabled: !this.showFlopContent,
        },
        {
          text: this.$t('browse.filter_categories.eq_buckets_advanced'),
          payload: 'eqBucketsAdvanced',
          disabled: !this.showFlopContent,
        },
      ]
    },
    // styleEqBuckets() {
    // return this.$store.getters.mergedUserSettings.styleEqBuckets
    // },
  },
}
</script>
<style lang="scss" scoped>
.rabbuildrcntr {
  --gap: var(--laytsttd-gap, 0.5rem);
  --padding-content: var(--laytsttd-padding-content, 0.5rem);
  --padding-content-mobile: 0.5rem 0.5rem 0 0.5rem;
  --center-width: clamp(16rem, 18rem, 19.5vw);

  display: flex;
  flex-direction: column;

  padding: var(--padding-content);
  min-width: calc(var(--center-width) + var(--gap));
  min-height: 0;
  max-height: 100%;
  flex: 1;
  &_top {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-top: -1.5rem;
    .rb-finish-mesage {
      margin-top: 0.75rem;
      padding: 0 1.5rem;
    }
  }
  &_blocks {
    display: flex;
    flex-direction: column;
    min-height: 0;
    gap: 1rem;
    overflow-y: auto;
    overflow-x: hidden;
  }
  &_block {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    &_items {
      display: flex;
      flex-direction: column;
      gap: 2px;
    }
  }
}

@media (max-width: 1023px) {
  .rabbuildrcntr {
    --padding-content: var(--padding-content-mobile);
  }
}
</style>
